export class Cartao{
    id: number;
    holder: string;
    cardNumber: string;
    expirationDate: string;
    brand: string;
    saveCard: boolean;
    number: string;
    selected: boolean;
}